// Autonomous Building Optimizer (heuristic mock)

export type OptimizerInput = {
  energy_kWh: number;
  water_liters: number;
  temp_celsius: number;
  outsideTemp: number;
  occupancyLevel: number; // 0..1
  energyPriceEurPerKWh: number;
};

export type OptimizerOutput = {
  hvacAdjustment: string; // e.g., "-1°C setpoint"
  lightDimPercent: number; // 0..100
  waterPolicy: string; // e.g., "reduce irrigation"
  estimatedCo2SavedKg: number;
  estimatedCostSavedEur: number;
};

export function optimizeBuilding(i: OptimizerInput): OptimizerOutput {
  // Basic heuristics
  const tooWarm = i.temp_celsius > 23 && i.outsideTemp < i.temp_celsius;
  const hvac = tooWarm ? '-1°C setpoint' : 'hold';
  const dim = Math.max(0, Math.min(40, (1 - i.occupancyLevel) * 60));
  const water = i.outsideTemp < 5 ? 'reduce irrigation' : 'normal';

  // Savings estimate (mock): 2% of energy per -1°C + dim%*0.3% + water 1%
  const energySavePct = (tooWarm ? 0.02 : 0) + (dim / 100) * 0.003 + (water === 'reduce irrigation' ? 0.01 : 0);
  const savedKWh = i.energy_kWh * energySavePct;
  const savedCo2 = savedKWh * 0.233; // EU avg
  const savedCost = savedKWh * i.energyPriceEurPerKWh;

  return {
    hvacAdjustment: hvac,
    lightDimPercent: Math.round(dim),
    waterPolicy: water,
    estimatedCo2SavedKg: parseFloat(savedCo2.toFixed(2)),
    estimatedCostSavedEur: parseFloat(savedCost.toFixed(2))
  };
}



















